import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionEmpresaResponsablesComponent {
  agregando = false
  idProyecto

  constructor (ViaticosProyectosProyectoResponsables) {
    this.ViaticosProyectosProyectoResponsables = ViaticosProyectosProyectoResponsables
  }

  $onChanges (changes) {
    if (changes.idProyecto) {
      this.idProyecto = changes.idProyecto.currentValue
      this.agregando = false
      this.promise = this.ViaticosProyectosProyectoResponsables.get(this.idProyecto)
        .then(({data}) => (this.responsables = data))
    }
  }

  agregar (data) {
    this.responsables = this.responsables.concat(data)
  }

  eliminar (item) {
    this.responsables = this.responsables.filter((elemento) => (elemento.usuario != item.usuario)) // Fixme
  }
}

module.component('viaticosConfiguracionEmpresaResponsables', {
  controller: ViaticosConfiguracionEmpresaResponsablesComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})




// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/empresa/responsables/component.js